import { Fragment } from "react";
import { NEWSROOM_LEADERSHIP } from "@routes/Content/layout/AboutUsLayout/utils/constants";

const AboutUsLeadershipDetails = (): React.ReactElement => {
  return (
    <div data-testid="about-us-table-component" className="mb-12">
      {NEWSROOM_LEADERSHIP.map(({ group, members }, index: number) => {
        return (
          <Fragment key={index}>
            {group ? <h4 className="mt-6">{group}</h4> : null}

            <table className="w-full table-fixed">
              <tbody>
                {members.map(({ name, position }, index: number) => {
                  return (
                    <tr key={index} className="border-b">
                      <td className="p-2">
                        <em>{name}</em>
                      </td>

                      <td>{position}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Fragment>
        );
      })}
    </div>
  );
};

export default AboutUsLeadershipDetails;
